import type { CheckoutItemSource, CheckoutMoney } from './checkout_source.js';

/**
 * Sum of every checkout item's price — the cart total. A single-item checkout
 * (rental/hotel/bus/mobility/one-way flight) sums to that item's own price
 * (backward compatible); a multi-trecho flight sums each leg's per-seat fare.
 * Currency comes from the first item — one checkout shares a single currency.
 */
export function sumItems(items: readonly CheckoutItemSource[]): CheckoutMoney {
  const amount = items.reduce((total, item) => total + item.price.amount, 0);
  return { amount, currency: items[0]?.price.currency ?? 'BRL' };
}
